module.exports = __webpack_public_path__ + "img/img-12.523dbb6b.png";